import Slider from "./slider";

export default function(el) {
    const slider = Slider(el);

    const switchClass = (index, actionType = "add") => el.classList[actionType](`ft--active-${index + 1}`);

    if (!slider) return;

    switchClass(0);

    slider.events.on("indexChanged", (sliderInfo) => {
        switchClass(sliderInfo.indexCached, "remove");
        switchClass(sliderInfo.index);
    });
}
